var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 81 81"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M40.5 5.206C21.008 5.206 5.206 21.008 5.206 40.5c0 19.492 15.802 35.294 35.294 35.294 19.492 0 35.294-15.802 35.294-35.294 0-19.492-15.802-35.294-35.294-35.294ZM.5 40.5c0-22.091 17.909-40 40-40s40 17.909 40 40-17.909 40-40 40-40-17.909-40-40Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#loader_svg__a)",
    fillRule: "evenodd",
    d: "M38.147 2.853C38.147 1.553 39.2.5 40.5.5c22.091 0 40 17.909 40 40s-17.909 40-40 40a39.852 39.852 0 0 1-26.001-9.602 2.353 2.353 0 1 1 3.06-3.575 35.146 35.146 0 0 0 22.94 8.471c19.493 0 35.295-15.802 35.295-35.294 0-19.492-15.802-35.294-35.294-35.294a2.353 2.353 0 0 1-2.353-2.353Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "loader_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -65.8824 119.757 0 16.03 68.735)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47A27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A27C",
    stopOpacity: 0
  })))));
};
export default SvgLoader;